import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import { ADD_BADGE, DELETE_BADGE, EDIT_BADGE, FETCH_BADGES } from './actions';

const badgesReducer = getApiReducer(FETCH_BADGES);
const badges = (state, action) => {
  let newState = badgesReducer(state, action);

  if (action.type === `${ADD_BADGE}_SUCCESS`) {
    newState = newState.set('data', newState.get('data').push(fromJS(action.json)));
  }

  if (action.type === `${DELETE_BADGE}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === parseInt(action.badgeId, 10));

    newState = newState.set('data', data.delete(index));
  }

  if (action.type === `${EDIT_BADGE}_SUCCESS`) {
    const data = newState.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    newState = newState.set('data', data.set(index, fromJS(action.json)));
  }

  return newState;
};

export default combineReducers({
  badges,
});



// WEBPACK FOOTER //
// ./src/badges/reducers.js